<template>
    <div class="cols-min-minmax"
         @click="click">
        <!-- Left -->
        <div v-if="withAvatar"
             class="f-center _p-0.5">
            <div v-if="avatar"
                 :class="classes.avatar"
                 :style="styles.avatar" />
            <el-avatar v-else
                       :class="classes.avatarEmpty"
                       icon="el-icon-office-building" />
        </div>
        <!-- Right -->
        <div :class="classes.right">
            <!-- Name -->
            <div class="f f-y-center space-x-1">
                <is-label :value="name || addressResult"
                          :dark="dark"
                          :color="nameColor || (selected ? 'accent' : null)"
                          :primary="namePrimary"
                          truncate
                          compact />

                <span class="f f-y-center space-x-0.25">
                    <el-tag v-if="astOrganizationProject"
                            size="mini">
                        ACT
                    </el-tag>
    
                    <el-tag v-if="isAstOrganizationProjectUnactive"
                            type="info"
                            size="mini">
                        {{ astOrganizationProjectStatusTranslated }}
                    </el-tag>
                </span>
            </div>

            <!-- Address -->
            <el-tooltip v-if="withAddress"
                        placement="bottom-start"
                        :disabled="!withAddressTooltip"
                        :content="addressResult"
                        :enterable="false">
                <is-label 
                    :value="addressResult"
                    :dark="dark"
                    :color="selected ? 'accent' : null"
                    tertiary
                    truncate
                    compact />
            </el-tooltip>

            <!-- Id -->
            <el-tooltip v-if="withIdentifier"
                        placement="bottom-start"
                        :content="identifierResult"
                        :enterable="false">
                <is-label 
                    :value="identifierResult"
                    :dark="dark"
                    :color="selected ? 'accent' : null"
                    tertiary
                    truncate
                    compact />
            </el-tooltip>

            <slot />
        </div>
    </div>
</template>

<script>
import { getAstOrganizationProject, getAstOrganizationProjectStatus } from '@/models/projects';
import { toCapitalCase } from '@/utils/format';

export default {
  props: {
    project: { type: Object, default: null },
    identifier: { type: String, default: null },
    address: { type: String, default: null },

    nameColor: { type: String, default: null },
    namePrimary: { type: Boolean, default: false },

    withAddress: { type: Boolean, default: false },
    withAddressTooltip: { type: Boolean, default: false },
    withAvatar: { type: Boolean, default: false },
    withIdentifier: { type: Boolean, default: false },

    selected: { type: Boolean, default: false },

    compact: { type: Boolean, default: false },

    dark: { type: Boolean, default: false }
  },
  computed: {
    classes() {
      return {
        avatar: {
          'rounded': true,
          'w-6 h-3.5': !this.compact,
          'wh-2': this.compact
        },
        avatarEmpty: {
          'f-center': true,
          'wh-3': !this.compact,
          'wh-2': this.compact
        },
        right: {
          'f-col f-x-center _px-0.5': true,
          '_py-0.5': !this.withAddress && !this.withAvatar
        }
      }
    },

    styles() {
      return {
        avatar: [
          `background-image: url("${this.avatar}")`,
          'background-size: cover',
          'background-position: center'
        ].join(';')
      }
    },

    name() {
      return this.project?.name
    },

    addressResult() {
      return this.address || this.project?.address || 'Адрес не указан'
    },

    identifierResult() {
      return this.identifier || this.project?.id
    },

    avatar() {
      return this.project?.avatar?.storage_thumb_url
    },

    astOrganizationProject() {
      return getAstOrganizationProject(this.project)
    },

    astOrganizationProjectStatus() {
      return getAstOrganizationProjectStatus(this.project)
    },

    astOrganizationProjectStatusTranslated() {
      return this.astOrganizationProjectStatus && toCapitalCase(this.astOrganizationProjectStatus.translated_name) || ''
    },

    isAstOrganizationProjectUnactive() {
      return this.astOrganizationProjectStatus?.value === 'unactive'
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e)
    }
  }
}
</script>
